import { get } from './client';

export const getSessionId = async (): Promise<string> => {
  const res = await get<{ id: string }>(`/v1/session`);
  return res.id;
};
